<template>
   <div class="BoardDetailsx">
      <div v-if="model" class="board">
        <b-breadcrumb v-if="hubInterface()">
            <b-breadcrumb-item tag="router-link" type="is-info" :to="{ path: '/explore' }">Explore</b-breadcrumb-item>
            <b-breadcrumb-item :to="'/models/'+ model.id">{{ model.name }}</b-breadcrumb-item>
            <b-breadcrumb-item :to="'/models/'+ model.id" active>{{ stepId | capitalize }}</b-breadcrumb-item>
        </b-breadcrumb>
        <b-breadcrumb v-else>
            <b-breadcrumb-item tag="router-link" type="is-info" :to="{ path: '/dashboard' }">Project</b-breadcrumb-item>
            <b-breadcrumb-item :to="'/models/'+ model.id">{{ model.name || model.id }}</b-breadcrumb-item>
            <b-breadcrumb-item :to="'/models/'+ model.id" active>{{ stepId | capitalize }}</b-breadcrumb-item>
        </b-breadcrumb>
        
         <div class="columns">
            <div class="column is-one-quarter">
               <b-menu>
                 <b-progress v-if="model.is_training" 
                 type="is-success"
                 size="is-medium" 
                 :value="model.training_status"
                 show-value 
                 format="percent">
                   <span v-if="model.training_status > 0 && model.training_status < 100">
                     Training {{ model.training_status }}%
                   </span>
                   <span v-else-if="model.training_status == 100">
                     Training completed
                   </span>
                   <span v-else>
                     Starting training
                   </span>
                 </b-progress>
                  <b-menu-list label="">
                     <b-menu-item v-for="item in getItems()" :key="item.id" 
                      :label="item.name" 
                      :active="stepId === item.id"
                      :disabled="isDisabled(item.id)"
                      tag="router-link"
                      :to="'/models/'+ model.id +'/'+ item.id">
                     </b-menu-item>
                  </b-menu-list>
               </b-menu>
            </div>
            <div class="column">
               <div class="page-info" >
                 
                 <Data v-if="stepId === 'datasets'" :model="model" />
                 <Training v-if="stepId === 'training'" :model="model"/>
                 <ErrorAnalysis v-if="stepId === 'error-analysis'" :model="model" :dataset="dataset"/>
                 <Explainability v-if="stepId === 'explainability'" :model="model"/>
                 <Invoke v-if="stepId === 'demo'" :model="model" :modelId="model.id" :currentUser="currentUser"/>
                 <API v-if="stepId === 'inference-api'" :model="model" :modelId="model.id" :currentUser="currentUser"/>
                 <Monitoring v-if="stepId === 'monitoring'" :model="model" :datasetId="model.datasets[0]" />
                 <Setup v-if="stepId === 'settings' && !hiddenSettings()" :model="model" :currentUser="currentUser"/>
                 
                  
               </div>
            </div>
         </div>
      </div>
      <div v-else>
        <h3 class="title is-5">
          <b-loading :is-full-page="true" v-model="requestIsLoading" :can-cancel="false">
          </b-loading>
          <span v-if="!requestIsLoading">
            Not available for your Plan. Request access to support@metatext.io
          </span>
          
        </h3>
        
      </div>
   </div>
</template>

<script>
   import Setup from "@/dashboard/Model/Setup.vue";
   import Data from "@/dashboard/Model/Data.vue";
   import Training from "@/dashboard/Model/Training.vue";
   import Invoke from "@/dashboard/Model/Invoke.vue";
   import API from "@/dashboard/Model/API.vue";
   import Monitoring from "@/dashboard/Model/Monitoring.vue";
   import Explainability from "@/dashboard/Model/Explainability.vue";
   import ErrorAnalysis from "@/dashboard/Model/ErrorAnalysis.vue";
   

   export default {
     props: ["modelId","stepId"],
     name: "ModelDetails",
     data: () => {
       return {
        requestIsLoading: false,
        currentTab: null,
        items: [
          // {
          //   name: "Datasets", id: "datasets"
          // },
          {
            name: "Training", id: "training"
          },
          {
            name: "Explain", id: "explainability"
          },
          {
            name: "Playground", id: "demo"
          },
          {
            name: "API", id: "inference-api"
          },
          
          // // {
          // //   name: "Monitoring", id: "monitoring"
          // // },
          {
            name: "Settings", id: "settings"
          }
        ]
       }
     },
     components: {
        Setup,
        Data,
        Training,
        Invoke,
        API,
        Monitoring,
        Explainability,
        ErrorAnalysis
     },
     computed: {
       model() {
         return this.$store.state.currentModel;
       },
       currentUser() {
         return this.$store.state.currentUser;
       },
       dataset() {
         return this.$store.state.dataset;
       }
     },
     created() {
      //  if (this.model.public || this.model.userId == "public") {
      //     this.items = this.items.filter(x => x.id !== 'settings')
      //  }

       this.currentTab = this.stepId
       this.$store.dispatch("currentModel", this.modelId);
       this.$store.dispatch("currentUser");
       this.$store.dispatch("currentDataset", this.model.datasets[0]);
       

       this.training = true
       this.options = {},
       this.series = [44, 55, 41, 17, 15]


           
        setTimeout(() => 
          this.requestIsLoading = false, 
        1 * 1000)
    
     },
     filters: {
      capitalize: function (value) {
        if (!value) return ''
        value = value.toString()
        if(value.toLowerCase() == 'api') return value.toUpperCase()
        if(value.toLowerCase() == 'error-analysis') return 'Error Analysis'
        if(value.toLowerCase() == 'inference-api') return 'Inference API'
        if(value.toLowerCase() == 'demo') return 'Playground'
        else return value.charAt(0).toUpperCase() + value.slice(1)
      }
    },
     methods: {
       hiddenSettings(){
         if (this.currentUser){
            return (this.model.public && (this.model.userId != this.currentUser.id))
        } else {
          return true
        }
       },
       hubInterface(){
        if (this.model.hub_only){
          return this.model.hub_only
        } else {
          return false
        }
       },
       getItems(){
         let items = this.items

         if (this.hubInterface()){
           if (this.hiddenSettings()){
              return items.filter(x => ['demo', 'inference-api'].includes(x.id))  
           } else {
              return items.filter(x => ['demo','settings', 'inference-api'].includes(x.id))
           }
           
         }
         
         if (this.hiddenSettings()){
            items = items.filter(x => x.id !== 'settings')
         }
         return items
       },
       isDisabled(stepId){
         
         var disableItems = ['explainability','invoke', 'error-analysis', 'inference-api', 'monitoring']
         if(disableItems.includes(stepId) && this.model.is_training) return true
         else return false
       },
       isTraining(){
         return true
       },
       trainingStatus(){
         return null
       },
       updateMenu(tab){
         this.currentTab = tab
       },
       async deleteBoard() {
         if (confirm("Are you sure")) {
           this.$store.dispatch("deleteBoard", this.boardId);
           this.$router.back();
         }
       },
       trainingStatus() {
         this.training = false
       },
       editBoard() {
         this.$store.commit("setModal", {
           component: "board-editor",
           data: {
             board: this.board
           }
         });
       },
       deleteItem(item) {
         if (confirm("Are you sure ?")) {
           this.$store.dispatch("deleteItem", item.id);
         }
       },
       addItem() {
         this.$store.commit("setModal", {
           component: "new-item",
           data: { boardId: this.boardId }
         });
       }
     }
   };
</script>

<style lang="scss" scoped>
.BoardDetails {
  .board {
    .items {
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
      gap: 16px;

      .item {
        position: relative;

        &:hover {
          .actions {
            display: unset;
          }
        }

        a {
          color: inherit;
          text-decoration: none;
        }

        .image-container {
          width: 100%;
          padding-top: 56.25%;
          overflow: hidden;
          background: #dedede;
          position: relative;
          border-radius: 4px;
          box-shadow: 1px 1px 1px #adadad;

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            position: absolute;
            top: 0;
            left: 0;
          }
        }

        .info {
          margin-top: 12px;

          .title {
            display: block;
            margin-bottom: 4px;
            text-transform: capitalize;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
            overflow: hidden;
          }
          .description {
            margin: 0;
            margin-bottom: 8px;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
          }
          .hostname {
            display: block;
            color: #a3a3a3;
          }
        }

        .actions {
          position: absolute;
          display: none;
          right: 0;
          top: 0;
          margin: 8px;

          .action {
            border: solid 1px black;
            padding: none;
            background: white;
            border-radius: 50%;
            width: 24px;
            height: 24px;
            outline: none;
          }
        }
      }
    }
  }
}
</style>
